import client from './client';

export function getSrhtExamReferenceOptions() {
  return client.get('/api/srht-exams/reference/options');
}

export function getSrhtExams() {
  return client.get('/api/srht-exams/exams');
}

export function getSrhtExam(examId) {
  return client.get(`/api/srht-exams/exams/${examId}`);
}

export function exportSrhtExamFullChainPdf(examId, data = {}) {
  return client.post(`/api/srht-exams/exams/${examId}/export-full-chain-pdf`, data, {
    responseType: 'blob',
  });
}

export function createSrhtExam(data) {
  return client.post('/api/srht-exams/exams', data);
}

export function updateSrhtExam(examId, data) {
  return client.put(`/api/srht-exams/exams/${examId}`, data);
}

export function closeSrhtExam(examId) {
  return client.post(`/api/srht-exams/exams/${examId}/close`);
}

export function unlockSrhtExam(examId, data) {
  return client.post(`/api/srht-exams/exams/${examId}/unlock`, data);
}

export function deleteSrhtExam(examId) {
  return client.delete(`/api/srht-exams/exams/${examId}`);
}

export function saveSrhtWrittenExamResult(examId, candidateId, data) {
  return client.put(`/api/srht-exams/exams/${examId}/candidates/${candidateId}/written-result`, data);
}

export function finalizeSrhtWrittenExamResult(examId, candidateId) {
  return client.post(`/api/srht-exams/exams/${examId}/candidates/${candidateId}/written-result/finalize`);
}

export function unlockSrhtWrittenExamResult(examId, candidateId, data) {
  return client.post(`/api/srht-exams/exams/${examId}/candidates/${candidateId}/written-result/unlock`, data);
}

export function saveSrhtPracticalSheet(examId, stationCode, data) {
  return client.put(`/api/srht-exams/exams/${examId}/practical-sheets/${stationCode}`, data);
}

export function updateSrhtPracticalTimerSession(examId, stationCode, data) {
  return client.put(`/api/srht-exams/exams/${examId}/practical-sheets/${stationCode}/timer-session`, data);
}

export function finalizeSrhtPracticalSheet(examId, stationCode, data) {
  return client.post(`/api/srht-exams/exams/${examId}/practical-sheets/${stationCode}/finalize`, data || {});
}

export function unlockSrhtPracticalSheet(examId, stationCode, data) {
  return client.post(`/api/srht-exams/exams/${examId}/practical-sheets/${stationCode}/unlock`, data);
}

export function saveSrhtOralRetake(examId, candidateId, data) {
  return client.put(`/api/srht-exams/exams/${examId}/candidates/${candidateId}/oral-retake`, data);
}

export function setSrhtPersonalFinalResultsRelease(examId, release) {
  return client.put(`/api/srht-exams/exams/${examId}/personal-results-release`, { release });
}

export function setSrhtAllFinalResultsRelease(examId, release) {
  return client.put(`/api/srht-exams/exams/${examId}/final-results-release`, { release });
}